export const toTableRowItems = (items: TruckItem[]) =>
  items.map((item: TruckItem) => ({
    id: item.id,
    shopName: item.shopName || '',
    hubName: item.hubName || '',
    depositName: item.depositName || '',
    flowTypeValue: item.flowTypeValue || '',
    truckNumber: item.truckNumber || '',
    phoneNumber: item.phoneNumber || '',
    transportCode: item.transportCode || '',
    seals: item.seals || '',
    ticketCodes: item.ticketCodes || '',
    documentsConform: item.documentsConform || false,
    thermodiagramConform: item.thermodiagramConform || false,
    arrivalConform: item.arrivalConform || false,
    sealConform: item.sealConform || false,
    statusValue: item.statusValue || '',
    created: item.created || '',
    createdBy: item.createdBy || '',
    etransportStatus: item.etransportStatus || 'Inexistent',
    approvedDate: item.approvedDate || '',
    approver: item.approver || '',
    creationOperator: item.creationOperator || '',
    depositTemperature: item.depositTemperature,
    driverName: item.driverName || '',
    flowType: item.flowType || '',
    status: item.status || '',
    manualCreationDate: item.manualCreationDate || '',
    shopTemperature: item.shopTemperature
  }))
